// Define an enum for the metric types
export enum Metrics {
    ANALOG_BRANDS_NEW_DEPLOYED = 'ANALOG_BRANDS_NEW_DEPLOYED',
    ANALOG_BRANDS_NEW_DEPLOYED_STAGE = 'ANALOG_BRANDS_NEW_DEPLOYED_STAGE',
    ANALOG_BRANDS_NEW_TIME_SPENT = 'ANALOG_BRANDS_NEW_TIME_SPENT',
    ANALOG_BRANDS_NEW_TIME_SPENT_STAGE = 'ANALOG_BRANDS_NEW_TIME_SPENT_STAGE',
    ANALOG_BRANDS_EXISTING_DEPLOYED = 'ANALOG_BRANDS_OLD_DEPLOYED',
    ANALOG_BRANDS_EXISTING_DEPLOYED_STAGE = 'ANALOG_BRANDS_OLD_DEPLOYED_STAGE',
    ANALOG_BRANDS_EXISTING_TIME_SPENT = 'ANALOG_BRANDS_OLD_TIME_SPENT',
    ANALOG_BRANDS_EXISTING_TIME_SPENT_STAGE = 'ANALOG_BRANDS_OLD_TIME_SPENT_STAGE',
    ANALOG_PATTERNS_NEW_STORES = 'ANALOG_PATTERNS_NEW_STORES',
    ANALOG_PATTERNS_EXISTING_STORES = 'ANALOG_PATTERNS_EXISTING_STORES',
    ANALOG_TAGGER_COUNT = 'ANALOG_TAGGER_COUNT',
    ANALOG_MID_MATCH_DOWNTIME_MINUTES = 'ANALOG_MID_MATCH_DOWNTIME_MINUTES',
    ANALOG_QA_DOWNTIME_MINUTES = 'ANALOG_QA_DOWNTIME_MINUTES',
    ANALOG_ELASTIC_LOAD_TIME = 'ANALOG_ELASTIC_LOAD_TIME',
    ANALOG_ELASTIC_FAILURES = 'ANALOG_ELASTIC_FAILURES',
    SEAM_INPUT_DATA_ROWS = 'SEAM_INPUT_DATA_ROWS',
    SEAM_OUTPUT_DATA_ROWS = 'SEAM_OUTPUT_DATA_ROWS',
    SEAM_PROCESSING_TIME = 'SEAM_PROCESSING_TIME',
    SEAM_FAILURE_COUNT = 'SEAM_FAILURE_COUNT',
    SEAM_UNPROCESSED_PATTERNS = 'SEAM_UNPROCESSED_PATTERNS',
    SEAM_NEW_MID_MATCH_ACCURATE = 'SEAM_NEW_MID_MATCH_ACCURATE',
    SEAM_NEW_MID_MATCH_TOTAL = 'SEAM_NEW_MID_MATCH_TOTAL',
    SEAM_TRUE_POSITIVES = 'SEAM_TRUE_POSITIVES',
    SEAM_FALSE_POSITIVES = 'SEAM_FALSE_POSITIVES',
    SEAM_TRUE_NEGATIVES = 'SEAM_TRUE_NEGATIVES',
    SEAM_FALSE_NEGATIVES = 'SEAM_FALSE_NEGATIVES',
}
